interface VimeoEmbedProps {
	videoId: string;
	width?: string | number;
	height?: string | number;
	title?: string;
	autoplay?: boolean;
}

export function VimeoEmbed({ videoId, width = '100%', height = '100%', title = '', autoplay = true }: VimeoEmbedProps) {
	return (
		<div style={{ position: 'relative', paddingTop: '61.22%', height: 0 }}>
			<iframe
				allow="autoplay; fullscreen; picture-in-picture; clipboard-write;"
				frameBorder="0"
				height={height}
				src={`https://player.vimeo.com/video/${videoId}?autoplay=${autoplay ? 1 : 0}&amp;badge=0&amp;autopause=0&amp;player_id=0`}
				style={{
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
				}}
				title={title}
				width={width}
			></iframe>
		</div>
	);
}
